import { onViewLoad } from "jose_modern/on_view_load";
import { once } from "jose_modern/once";
import { fetchScript } from "recipal-app/controllers/shared/requests";

import { AllergenInput } from "../allergens/common.js";

const MODAL_SELECTOR = "#facility-allergens-modal[data-mode='default']";

onViewLoad("users#edit", () => {
  document.addEventListener("modal:open", (ev) => {
    const modal = ev.detail.modal;
    if (!modal.matches(MODAL_SELECTOR)) return;
    once(modal.querySelector(".allergen-editor"), "allergen-input", (editorRoot) => {
      new AllergenInput(editorRoot, () => {});
    });
  });

  document.addEventListener("click", async (ev) => {
    const saveBtn = ev.target.closest(`${MODAL_SELECTOR} [data-action='save']`);
    if (!saveBtn) return;

    const modal = saveBtn.closest("#facility-allergens-modal");
    const editorRoot = modal.querySelector(".allergen-editor");
    const prefixInput = modal.querySelector("[data-prefix-input]");
    const errorEl = modal.querySelector("[data-error]");

    errorEl.classList.add("is-hidden");

    if (AllergenInput.showIncompleteWarning(editorRoot)) return;

    saveBtn.classList.add("is-loading");
    try {
      const allergens = AllergenInput.collect(editorRoot);
      await fetchScript(modal.dataset.updateUrl, {
        method: "PATCH",
        body: JSON.stringify({
          facility_allergens: allergens,
          facility_allergens_prefix: prefixInput.value,
        }),
      });
    } catch (err) {
      console.error(err);
      errorEl.textContent = "Failed to update defaults.";
      errorEl.classList.remove("is-hidden");
    } finally {
      saveBtn.classList.remove("is-loading");
    }
  });
});
